
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16.97 17.54a2.24 2.24 0 100 4.47 2.24 2.24 0 000-4.47zm0 3.47a1.23 1.23 0 110-2.46 1.23 1.23 0 010 2.46zm5.98-15.84H5.19L4.88 3.9a2.47 2.47 0 00-2.4-1.88H1.25a.5.5 0 000 1h1.21c.68-.01 1.28.45 1.44 1.11l2.43 9.93a2.46 2.46 0 002.4 1.87h10.4c1.15 0 2.16-.79 2.41-1.92l1.89-8.24a.5.5 0 00-.49-.6zm-2.37 8.62a1.46 1.46 0 01-1.44 1.14H8.74c-.67 0-1.27-.46-1.43-1.11L5.44 6.17h16.88l-1.74 7.62zM10.2 17.54a2.24 2.24 0 100 4.47 2.24 2.24 0 000-4.47zm0 3.47a1.23 1.23 0 110-2.46 1.23 1.23 0 010 2.46z"}})])
          )
        }
      }
    